import React from "react";
import _ from "lodash";
import {
  compareTwoObjectsDiff,
  FirstLookSortedArray,
  FirstLookUniqIdMap,
  CustomGroupRule,
  CustomRuleAliasKey,
} from "helpers/Compare";
import ConfigDiffView from "components/common/ConfigDiffView";
import SaveChangedHintWidget from "components/common/SaveChangedHintWidget";

import { TYPE } from "./Constants";

class CustomFirstLookDiffView extends React.PureComponent {
  render() {
    const {
      originalRules,
      newRules,
      handleRollBack,
      refData,
      isInModal = false,
    } = this.props;

    const diffByType = _.values(TYPE).reduce((acc, type) => {
      const diffs = compareTwoObjectsDiff(
        originalRules[type] || [],
        newRules[type] || [],
        FirstLookUniqIdMap,
        FirstLookSortedArray
      );

      acc[type] = diffs;

      return acc;
    }, {});

    const diffCount = _.sumBy(_.values(diffByType), (diffs) => diffs.length);

    return (
      <>
        <ConfigDiffView
          diffs={diffByType}
          groupRule={CustomGroupRule}
          refData={refData}
          aliasKey={CustomRuleAliasKey}
          handleRollBack={handleRollBack}
        ></ConfigDiffView>
        {diffCount > 0 && !isInModal && (
          <SaveChangedHintWidget diffCount={diffCount} bottom="3rem" />
        )}
      </>
    );
  }
}

export default CustomFirstLookDiffView;
